<!-- Copyright (c) 2025 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="statusCategory-main">
    <Menus :menu="menus" @menuClicked="handleMenuClick" />
    <div class="right-container">
      <TableBox
        title="Status List Category"
        :tableData="statusCategoryList"
        :selectedRow.sync="selectedstatusCategory"
      />
    </div>

    <PopupEntry
      v-if="popupEntryShow"
      :show.sync="popupEntryShow"
      :title="popUpTitle"
      @save="savestatusCategory"
      :requiredError="entryError"
      :errorMessages="errorMessage"
      :viewMode="viewMode"
      @requiredClicked="errorMessageClicked"
      :successMessages="successMessages"
      :createdBy="createdBy"
      :updatedBy="updatedBy"
    >
      <div class="popup-entry-container">
        <Input
          placeholder="Status List Category"
          :isDisabled="viewMode"
          :inputValue.sync="statusCategory"
          :isRequired="true"
          ref="statusCategory"
          :errorMessage.sync="statusCategoryError"
          validator="text,10,uppercase,alphanumeric,all"
        />
        <Input
          placeholder="Description"
          :isDisabled="viewMode"
          :inputValue.sync="description"
          :isRequired="true"
          ref="description"
          :errorMessage.sync="descriptionError"
          validator="text,50,alphanumeric,all"
        />
        <InputQuery
          placeholder="Job Type"
          :isDisabled="viewMode"
          :items="jobTypeList"
          :allowFreeText="false"
          :selectedObject.sync="selectedJobType"
          itemKey="JobType"
          descKey="JobTypeText"
          validator="text,50,uppercase,alphanumeric,all"
        />
        <CheckBoxV2 title="Print to Job File?" :isChecked.sync="printToJobFile" :isDisabled="viewMode" />
        <div class="statuslist-tablebox" v-if="showTable">
          <div class="statusTaskCode-table-buttons">
            <button @click="showStatusTaskCodePopup = true" :disabled="viewMode">
              <img src="https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png" alt="Add Status" />
              Add Status
            </button>
            <button :disabled="viewMode" @click="statusReorderingMenuMoveUpClicked">
              <img src="https://dsmlib.logistics.systems/Icons/icons8-up-arrow-26.png" alt="Move Up" />
              Move Up
            </button>
            <button :disabled="viewMode" @click="statusReorderingMenuMoveDownClicked">
              <img src="https://dsmlib.logistics.systems/Icons/icons8-down-arrow-26.png" alt="Move Down" />
              Move Down
            </button>
          </div>
          <div class="statusTaskCode-table-main-content">
            <div
              v-if="selectedStatusList.length !== 0"
              class="status-card status-header"
              style="margin-right: 7px; cursor: default"
            >
              <!-- prettier-ignore -->
              <span>Status     -     Description</span>
              <span>Total {{ selectedStatusList.length }} Status</span>
            </div>
            <div id="view-details">
              <span v-if="selectedStatusList.length === 0"
                >Click on <strong>Add Status</strong> to add status to this category</span
              >
              <div
                v-for="status in selectedStatusList"
                :key="status['Status']"
                :class="getStatusReorderingMenuStatusCardClasses(status)"
                @click="statusReorderingMenuStatusClicked(status)"
              >
                <!-- prettier-ignore -->
                <span>{{status['statusname']}} -     {{status['Status Description']}}</span>
                <img
                  v-if="!viewMode"
                  class="delete-status-icon"
                  src="https://dsmlib.logistics.systems/Icons/Delete.png"
                  alt="Delete Status"
                  title="Delete Status"
                  @click="statusReorderingMenuDeleteStatusClicked($event, status)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </PopupEntry>

    <div v-if="showStatusTaskCodePopup" class="statusTaskCode-popup-container">
      <div class="statusTaskCode-popup">
        <div class="statusTaskCode-group-header">
          <BoxContainer title="Status Groups" :isCheckBox="false">
            <div v-if="addStatusGroupList && addStatusGroupList.length > 0" class="statusGroup-container">
              <div
                v-for="(statusGroup, statusGroupIndex) in addStatusGroupList"
                :key="'statusGroup_' + statusGroupIndex"
                class="statusGroupCheckbox-container"
              >
                <CheckBoxV2 :title="statusGroup['Group Name']" :isChecked.sync="statusGroup['isChecked']" />
              </div>
            </div>
          </BoxContainer>
        </div>
        <div class="statusTaskCode-table">
          <TableBox
            v-if="showAddStatusTaskCodePickListTable"
            title="Status Task Code List"
            :tableData="addStatusTaskCodePickList"
            :selectedRow.sync="addStatusTaskCodeSelectedRows"
            :showSelectAll="true"
            :maxSelection="-1"
            :hideColumns="['Group']"
          />
        </div>
        <div class="statusTaskCode-button">
          <button @click="addStatusAddButtonClick()">Add</button>
          <button @click="addStatusCancelButtonClick()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showTable: true,
      menus: [
        {
          title: 'New Status List Category',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png',
          key: 'MnuNew',
          visible: true,
          enabled: true,
        },
        {
          title: 'Edit Status List Category',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png',
          key: 'MnuEdit',
          visible: true,
          enabled: true,
        },
        {
          title: 'Delete Status List Category',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png',
          key: 'MnuDelete',
          visible: false,
          enabled: true,
        },
        {
          title: 'View Status List Category',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png',
          key: '',
          visible: true,
          enabled: true,
        },
      ],

      //Table
      statusCategoryList: [],
      selectedstatusCategory: [],
      selectedStatusList: [],
      statusReorderingMenuSelectedStatus: {},
      jobTypeList: [],
      statusCodeList: [],

      // Nested Add Popup state
      showStatusTaskCodePopup: false,
      addStatusGroupList: [],
      // selectedAddStatusGroups: [],
      addStatusTaskCodePickList: [],
      showAddStatusTaskCodePickListTable: true,
      addStatusTaskCodeSelectedRows: [],

      // Pop up box setting
      popupEntryShow: false,
      popUpTitle: '',
      entryError: [],
      errorMessage: [],
      successMessages: [],
      viewMode: false,
      saveOption: '',
      createdBy: '',
      updatedBy: '',
      description: '',
      statusCategory: '',
      selectedJobType: {},
      printToJobFile: false,

      //Error Message
      statusCategoryError: '',
      descriptionError: '',
    };
  },
  props: {},
  methods: {
    handleMenuClick: async function (menu) {
      this.errorMessage = [];
      this.entryError = [];
      this.successMessages = [];
      this.clearInputFields();

      switch (menu.title) {
        case 'View Status List Category':
          if (this.selectedstatusCategory.length == 0) {
            this.$showAlert('error', 'No Status List Category Selected', 'Please select a record to view');
            return;
          }

          await this.getSpecificStatusCategory(this.selectedstatusCategory[0]['Status List Category']);
          this.viewMode = true;
          this.popUpTitle = 'View Status List Category';
          this.popupEntryShow = true;
          break;
        case 'Edit Status List Category':
          if (this.selectedstatusCategory.length == 0) {
            this.$showAlert('error', 'No Status List Category Selected', 'Please select a record to edit');
            return;
          }

          await this.getSpecificStatusCategory(this.selectedstatusCategory[0]['Status List Category']);
          this.saveOption = 'E';
          this.viewMode = false;
          this.popUpTitle = 'Edit Status List Category';
          this.popupEntryShow = true;
          break;
        case 'New Status List Category':
          this.saveOption = 'N';
          this.viewMode = false;
          this.popUpTitle = 'New Status List Category';
          this.popupEntryShow = true;
          break;
        case 'Delete Status List Category': {
          if (this.selectedstatusCategory.length == 0) {
            this.$showAlert('error', 'No Status List Category Selected', 'Please select a record to delete');
            return;
          }
          const deleting = await this.$showAlert(
            'warning',
            'Delete Status List Category',
            `Are you sure you want to delete Status List Category ${this.selectedstatusCategory[0]['Status List Category']} ?`,
            [
              { text: 'Delete', textColor: 'white', color: 'red' },
              { text: 'Cancel', textColor: 'black', color: 'lightgray' },
            ],
          );

          if (deleting == 'Cancel') {
            return;
          }

          this.$fullscreenLoading('Deleting Status Group');
          const result = await this.$apiCallV2('/StatusListCategory/SaveStatusListCategory', {
            action: 'D',
            listcategory: this.selectedstatusCategory[0]['Status List Category'],
          });
          this.$fullscreenLoading();
          if (result[0]['Results'] == 0) {
            this.$showAlert(
              'success',
              'Status Group Deleted',
              `Successfully deleted Status Group ${this.selectedstatusCategory[0]['Status List Category']}`,
            );
            this.$nextTick(async () => await this.getAllStatusCategoryDetails());
            this.selectedstatusCategory = [];
            return;
          }
          this.$showAlert(
            'error',
            'Status Group NOT Deleted',
            `There was an error deleting Status Group : ${this.selectedstatusCategory[0]['Status List Category']}`,
          );
          break;
        }
      }
    },
    getAllStatusCategoryDetails: async function () {
      this.statusCategoryList = [];
      this.statusCategoryList = await this.$apiCallV2('/Master/GetListMaster', {
        masterfile: 'STATUSLISTCATEGORY',
        module: 'MASTERFILES',
      });
    },
    getjobTypeList: async function () {
      this.jobTypeList = await this.$apiCallV2('/Master/GetListMaster', {
        masterfile: 'JOBTYPE',
      });
    },
    getSpecificStatusCategory: async function (record) {
      this.$fullscreenLoading('Loading Status Category Details');
      this.selectedStatusList = [];
      let statusCategoryDetails = await this.$apiCallV2('/Master/GetDetailsMaster', {
        masterfile: 'STATUSTASKCATEGORY',
        recordid: record,
      });
      if (statusCategoryDetails) {
        statusCategoryDetails = statusCategoryDetails['StatusTaskCategory'];
      } else {
        this.$showAlert('Error', 'Record Missing', `Record ${record} not found`);
        return;
      }
      this.selectedStatusList = statusCategoryDetails['StatusList'].map((item) => ({
        ...item,
        statusname: item['Status'].padEnd(10, ' '),
      }));

      this.statusCategory = statusCategoryDetails['statuslistcategory'] || '';
      this.description = statusCategoryDetails['description'] || '';
      const printToJobFileValue = statusCategoryDetails['printtojobfile'];
      this.printToJobFile = printToJobFileValue === '1';

      const jobType = statusCategoryDetails['jobtype'] || '';
      if (jobType) {
        this.selectedJobType = this.jobTypeList.getSelected(jobType, 'JobType');
      }

      this.$fullscreenLoading();
    },
    savestatusCategory: async function () {
      this.errorMessage = [];
      this.entryError = [];
      const isValid = this.checkFields();
      if (isValid) {
        const statusTaskCodeList = this.selectedStatusList.map((item, index) => {
          return {
            '#': index + 1,
            Status: item['Status'],
          };
        });

        const dataToPost = {
          listcategory: this.statusCategory,
          jobtype: this.selectedJobType && this.selectedJobType.JobType ? this.selectedJobType.JobType : '',
          description: this.description,
          action: this.saveOption,
          printtojobfile: this.printToJobFile ? '1' : '0',
          statustaskcodelist: statusTaskCodeList,
        };

        this.$fullscreenLoading('Saving Status List Category');
        const postUpdate = await this.$apiCallV2('/StatusListCategory/SaveStatusListCategory', dataToPost);
        this.$fullscreenLoading();

        if (postUpdate[0]['Results'] == 0) {
          if (this.saveOption == 'N') {
            this.successMessages.push(`Successfully created Status List Category : ${this.statusCategory}`);
          }
          if (this.saveOption == 'E') {
            this.successMessages.push(`Successfully edited Status List Category : ${this.statusCategory}`);
          }

          this.viewMode = true;
          this.disable = true;
          this.popUpTitle = 'View Status List Category';

          await this.getAllStatusCategoryDetails();
        } else {
          this.errorMessage.push(`There was an error saving the status category: ${postUpdate[0]['ErrMsg']}`);
        }
      }
    },
    errorMessageClicked: function (item) {
      this.$nextTick(() => {
        this.$refs[item].setFocus();
      });
    },
    clearInputFields: function () {
      this.statusCategory = '';
      this.selectedJobType = {};
      this.description = '';
      this.selectedStatusList = [];
      this.statusReorderingMenuSelectedStatus = {};
      this.printToJobFile = false;
      this.statusCategoryError = '';
      this.descriptionError = '';
    },
    checkFields: function () {
      if (!this.statusCategory || this.statusCategory.trim().length == 0) {
        this.statusCategoryError = 'Status Category is Required!';
        this.entryError.push({
          key: 'statusCategory',
          value: this.statusCategoryError,
        });
      }
      if (!this.description || this.description.trim().length == 0) {
        this.descriptionError = 'Description is Required!';
        this.entryError.push({
          key: 'description',
          value: this.descriptionError,
        });
      }
      return this.entryError.length == 0;
    },
    getAddStatusGroupList: async function () {
      this.addStatusGroupList = [];
      let resp = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'STATUSGROUP' });
      resp = resp.map((r) => ({
        ...r,
        isChecked: false,
      }));
      this.addStatusGroupList = resp;
      this.addStatusGroupList.sort((a, b) => {
        //sort by group name...
        const aName = (a['Group Name'] || a['Status Group'] || '').toString().toLowerCase();
        const bName = (b['Group Name'] || b['Status Group'] || '').toString().toLowerCase();
        if (aName < bName) return -1;
        if (aName > bName) return 1;
        return 0;
      });
    },
    addStatusAddButtonClick: function () {
      if (this.addStatusTaskCodeSelectedRows.length === 0) {
        this.$showAlert('error', 'No Status Selected', 'Please select a status to add', [{ text: 'OK' }]);
      }

      const statusesToAdd = [];
      this.addStatusTaskCodeSelectedRows.forEach((m) => {
        if (!this.selectedStatusList.some((s) => s.Status.toLowerCase() === m.Status.toLowerCase())) {
          statusesToAdd.push({
            '#': '',
            'Job Type': '',
            Status: m['Status'],
            'Status Description': m['Description'],
            statusname: m['Status'].padEnd(10, ' '),
            statuslistcategory: '',
          });
        }
      });

      let indexToAddAt;
      if (Object.keys(this.statusReorderingMenuSelectedStatus).length != 0) {
        indexToAddAt =
          this.selectedStatusList.findIndex((status) =>
            this.caseInsensitiveStringComparison(status['Status'], this.statusReorderingMenuSelectedStatus['Status']),
          ) + 1;
      } else {
        indexToAddAt = this.selectedStatusList.length;
      }
      this.selectedStatusList.splice(indexToAddAt, 0, ...statusesToAdd);

      this.addStatusCancelButtonClick();
    },
    addStatusCancelButtonClick: function () {
      this.addStatusGroupList.forEach((group) => {
        group['isChecked'] = false;
      });
      this.addStatusTaskCodePickList = [];
      this.addStatusTaskCodeSelectedRows = [];
      this.showStatusTaskCodePopup = false;
    },
    statusReorderingMenuStatusClicked: function (status) {
      if (
        !this.caseInsensitiveStringComparison(
          status['Status'],
          this.statusReorderingMenuSelectedStatus?.['Status'] ?? '',
        )
      ) {
        this.statusReorderingMenuSelectedStatus = status;
      } else {
        this.statusReorderingMenuSelectedStatus = {};
      }
    },
    statusReorderingMenuMoveUpClicked: function () {
      if (Object.keys(this.statusReorderingMenuSelectedStatus).length === 0) {
        this.$showAlert('error', 'No Status Selected', 'Please select a status to move', [{ text: 'OK' }]);
        return;
      }

      const selectedStatusIndex = this.selectedStatusList.findIndex((status) =>
        this.caseInsensitiveStringComparison(
          status['Status'],
          this.statusReorderingMenuSelectedStatus?.['Status'] ?? '',
        ),
      );
      if (selectedStatusIndex === 0) {
        //already at the top of the list
        return;
      }

      this.selectedStatusList.splice(selectedStatusIndex, 1);
      this.selectedStatusList.splice(selectedStatusIndex - 1, 0, this.statusReorderingMenuSelectedStatus);
    },
    statusReorderingMenuMoveDownClicked: function () {
      if (Object.keys(this.statusReorderingMenuSelectedStatus).length === 0) {
        this.$$showAlert('error', 'No Status Selected', 'Please select a status to move', [{ text: 'OK' }]);
        return;
      }

      const selectedStatusIndex = this.selectedStatusList.findIndex((status) =>
        this.caseInsensitiveStringComparison(
          status['Status'],
          this.statusReorderingMenuSelectedStatus?.['Status'] ?? '',
        ),
      );
      if (selectedStatusIndex === this.selectedStatusList.length - 1) {
        //already at the bottom of the list
        return;
      }

      this.selectedStatusList.splice(selectedStatusIndex, 1);
      this.selectedStatusList.splice(selectedStatusIndex + 1, 0, this.statusReorderingMenuSelectedStatus);
    },
    statusReorderingMenuDeleteStatusClicked: async function (pointerEvent, statusToDelete) {
      pointerEvent.stopPropagation(); //to prevent the status from being toggled as selected or unselected

      const deleteStatusConfirmation = await this.$showAlert(
        'warning',
        'Delete Status',
        `Are you sure you wish to delete the ${statusToDelete['Status']} status?`,
        [
          { text: 'Delete', color: 'red', textColor: 'white' },
          { text: 'Cancel', color: 'lightgray' },
        ],
      );

      if (deleteStatusConfirmation === 'Cancel') {
        return;
      }

      const indexOfStatusToDelete = this.selectedStatusList.findIndex((status) =>
        this.caseInsensitiveStringComparison(status['Status'], statusToDelete['Status']),
      );
      this.selectedStatusList.splice(indexOfStatusToDelete, 1);
      if (this.statusReorderingMenuSelectedStatus['Status'] === statusToDelete['Status']) {
        //selected status was deleted
        this.statusReorderingMenuSelectedStatus = {}; //unselect it
      }
    },
    getStatusReorderingMenuStatusCardClasses: function (status) {
      const CSSClasses = ['status-card'];

      if (
        !this.caseInsensitiveStringComparison(
          status['Status'],
          this.statusReorderingMenuSelectedStatus?.['Status'] ?? '',
        )
      ) {
        return CSSClasses;
      }
      return CSSClasses.concat('selected');
    },
    caseInsensitiveStringComparison: function (firstString, secondString) {
      return firstString.toLowerCase() === secondString.toLowerCase();
    },
  },
  mounted: async function () {
    this.$bus.$on('pageSASControlAccess', (x) => {
      if (x.page == 'Status List Category') {
        x.data.forEach((k) => {
          const selectedMenu = this.menus.find((m) => m['key'] == k['Control']);
          if (selectedMenu) {
            selectedMenu[k['Properties'].toLowerCase()] = k['PropertiesValue'] == 'True';
          }
        });
      }
    });
    this.$fullscreenLoading('Getting Data');
    this.getAllStatusCategoryDetails();
    this.getAddStatusGroupList();
    this.getjobTypeList();
    this.statusCodeList = await this.$apiCallV2('/Master/GetListMaster', {
      masterfile: 'STATUS',
      module: 'STATUSLISTCATEGORY',
    });
    this.$fullscreenLoading('');
  },
  watch: {
    addStatusGroupList: {
      deep: true,
      handler: function () {
        this.showAddStatusTaskCodePickListTable = false;
        this.addStatusTaskCodePickList = [];

        this.addStatusGroupList.forEach((group) => {
          if (group['isChecked'] == true) {
            const tempStatusCodeList = this.statusCodeList.filter((f) => f['Group'] == group['Status Group']);
            this.addStatusTaskCodePickList.push(...tempStatusCodeList);
          }
        });

        this.$nextTick(() => {
          this.showAddStatusTaskCodePickListTable = true;
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
.statusCategory-main {
  padding: 10px 45px;
  font-size: 12px;
  display: flex;

  > .right-container {
    background-color: white;
    padding: 5px;
    border-radius: 5px;
    width: 100%;
    margin-left: 5px;
    overflow: hidden;
  }

  > .statusTaskCode-popup-container {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1500;

    > .statusTaskCode-popup {
      height: 90%;
      width: 80%;
      padding: 10px;
      display: flex;
      flex-direction: column;
      background-color: white;
      border-radius: 5px;

      > .statusTaskCode-group-header {
        height: 150px;
        overflow: auto;
      }

      > .statusTaskCode-table {
        height: calc(100% - 180px);
      }

      > .statusTaskCode-button {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-top: 5px;

        > button {
          margin: 0 3px 0 3px;
        }
      }
    }
  }
}

.popup-entry-container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  > .add-delete-buttons {
    margin-top: 5px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }

  > .statuslist-tablebox {
    height: calc(100% - 115px);
    display: flex;
    flex-direction: row;
    margin-top: 5px;

    > .statusTaskCode-table-buttons {
      display: flex;
      flex-direction: column;

      > button {
        text-align: left;

        &:not(:first-child) {
          margin-top: 5px;
        }

        > img {
          height: 20px;
          width: 20px;
        }
      }
    }

    > .statusTaskCode-table-main-content {
      margin-left: 5px;
      flex: 1;
      display: flex;
      flex-direction: column;

      > #view-details {
        margin-top: 5px;
        overflow-y: scroll;
      }

      .status-card {
        min-height: 35px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border: 1px solid black;
        border-radius: 5px;
        padding-left: 5px;
        padding-right: 5px;
        cursor: pointer;
        white-space: pre-wrap;

        &:not(:first-child) {
          margin-top: 5px;
        }

        &:is(.selected) {
          background-color: rgb(130, 130, 130);
          color: white;
        }

        &:hover:not(.status-header) {
          background-color: rgb(200, 200, 200);
        }

        &:is(.status-header) {
          background-color: #535cda;
          color: white;
        }

        &:hover:is(.selected) {
          background-color: rgb(160, 160, 160);
          color: white;
        }

        > .delete-status-icon {
          height: 20px;
          width: 20px;
        }
      }
    }
  }
}

@media screen and (min-width: 1000px) {
  .statusGroup-container {
    display: inline-grid;
    grid-template-columns: auto auto auto auto;
  }
}
@media screen and (max-width: 1000px) {
  .statusGroup-container {
    display: inline-grid;
    grid-template-columns: auto auto auto;
  }
}
@media screen and (max-width: 600px) {
  .statusGroup-container {
    display: inline-grid;
    grid-template-columns: auto auto;
  }
}
</style>
